import { Component, OnInit } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { DialogConfig } from '../../dialog/dialog-config';
import _moment from 'proxies/dayjs';
@Component({
    selector: 'app-calendar-event-detail',
    templateUrl: './calendar-event-detail.component.html',
    styleUrls: ['./calendar-event-detail.component.scss'],
    standalone: false
})
export class CalendarEventDetailComponent implements OnInit {
  data: any;
  moment = _moment;
  value: any;
  resourceDef: any;
  config = { 
    "viewAll": true,
    "hideSearchBox": true,
    "hideResult": false,
    "allowPagination": false,
    "print_allowed": false,
  }

  constructor(
    private dialogConfig: DialogConfig,
    private baseService: BaseService,
    private loader: LoaderService,
    private alertService: AlertsService
  ) { }

  ngOnInit(): void {
    this.data = this.dialogConfig;
    this.baseService.getResourceDef(this.data.formResourec.datasource.detailResource, (data)=>{
      this.resourceDef = data.list.fields;
      this.getData()
    })
    
  }

  getData() {
    this.loader.showSpinner()
    let query_id = this.data.formResourec.datasource.query_id == undefined ? "GET_PAGE" : this.data.formResourec.datasource.query_id;
    let resource = this.data.formResourec.datasource.resource == undefined ? "" : this.data.formResourec.datasource.resource;
    let application = this.data.formResourec.datasource.application == undefined ? "" : this.data.formResourec.datasource.application;
    this.baseService.get(query_id, this.makeArgs(this.data.formResourec.datasource.args, this.data.data), resource, application).subscribe((res: any) => {
      this.loader.hideSpinner()
      if (res.errCode == 0) {
        this.value = res
      } else {
        this.alertService.error(res.message)
      }
    })
  }

  makeArgs(argument, value) {
    let str = argument;
    let data = {
      start_date: this.moment(value.start).valueOf(),
      end_date: this.moment(value.end).valueOf(),
      id: value.doctor_id,
      facility_id: value.facility_id,
      care_type: value.care_type
    }
    let result = str.match(/\!!!(.*?)\!!!/gm);
    for(let i = 0; i < result.length; i++) {
      str = str.replace(result[i], data[result[i].replace(/!!!/g, "")])
    }
    return str;
  }

}
